import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { 
  getAuth, 
  FacebookAuthProvider,
  GoogleAuthProvider
} from 'firebase/auth';


const firebaseConfig = {
  apiKey: "AIzaSyBmMY7khg6vuU-IEwVhk9HSRYZ9ESFIFDw",
  authDomain: "wurknest.firebaseapp.com",
  projectId: "wurknest",
  storageBucket: "wurknest.firebasestorage.app",
  messagingSenderId: "661860173601",
  appId: "1:661860173601:web:8a12abad06731f614ae060",
  measurementId: "G-CW1MXG2MKH"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


const auth = getAuth(app);

const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();
facebookProvider.addScope("email");
facebookProvider.addScope("public_profile");

facebookProvider.setCustomParameters({
  auth_type: "rerequest"
});
export { auth, googleProvider, facebookProvider };
